import type { Attachment } from '@medplum/fhirtypes'
import type { AvailResource } from '@/hooks/fhirSearchConfig.ts'
import { COMBINABLE_CONTENT_TYPES } from '@/model/middleware-types'

const isCombinable = (attachment: Attachment) =>
  !!attachment.url &&
  (COMBINABLE_CONTENT_TYPES as readonly string[]).includes(
    attachment.contentType?.split(';')[0].trim().toLowerCase() ?? '',
  )

/**
 * PD-1685 — whether a Labs/Imaging result or a Documents record can go into the combined PDF:
 * a record on the chart whose every file is a PDF or image. A result that only has values, or
 * a TEFCA (CCDA) / HTML document, is left out. The server applies the same rule.
 */
export function isCombinableRecord(resource: AvailResource): boolean {
  if (resource.resourceType === 'DiagnosticReport') {
    if (resource.status === 'entered-in-error') return false
    const forms = resource.presentedForm ?? []
    return forms.length > 0 && forms.every(isCombinable)
  }
  if (resource.resourceType === 'DocumentReference') {
    if (resource.status === 'entered-in-error') return false
    const attachments = (resource.content ?? []).map((content) => content.attachment)
    return attachments.length > 0 && attachments.every(isCombinable)
  }
  return false
}
